// Data.jsx


import tarar from "../../assets/blacklogo.png";
import Booksy from "../../assets/booksy.png";
import DostApp from "../../assets/DostApp.png";
import chatbot from "../../assets/chatbot.jpg";
// import IDP from "../../assets/IDP.jpg";
import StepPlay from "../../assets/finalStepPlay.png";




export const projectsData = [

  {
    id: 1,
    image: StepPlay,
    title: "StepPlay – iOS & Watch App",
    category: "app",
    description: "Dopamine-driven fitness app with HRV stress tracking, gamified milestones & HealthKit insights. Built  with SwiftUI + OpenAI.",
    link: "https://apps.apple.com/ca/app/stepplay/id6737176444"
  },


  {
    id: 2,
    image: Booksy,
    title: "E-Commerce Book Store",
    category: "web",
    description: "E-commerce book store, featuring user authentication, cart management, and payment processing.",
    link: "https://github.com/Fawaztarar/booksy-FT"
  },
  {
    id: 3,
    image: tarar,
    title: "Ios App TaskBook",
    category: "app",
    link: "https://apps.apple.com/ca/app/taskbook/id6499077243"
  },
  

  {
    id: 4,
    image: DostApp,
    title: "Ios App دوست",
    category: "web",
    description: "iOS Dost App in Urdu Language to share messages, images, videos and voice inpsired by WhatsApp",
    link: "https://example.com/project5"
  },

  {
    id: 5,
    image: chatbot,
    title: "AI-powered Chatbot",
    category: "web",
    description: "Developed a modern corporate website for a leading tech company.",
    link: "https://example.com/project1"
  },
];

// projects navigation categories
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
